import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Text, TextType } from 'ui-components/components/text';
import ModalPortal from '../../../../../components/modal-portal';
import messages from '../../messages';
import AsModal from '../../../../../components/as-modal';
import { SsrSignOnButton } from '../../../stores/selected-store/returns-tab/ssr-sign-on-button';
import Global from '../../../../../store/global-selectors';

import style from './style.module.less';

/**
 * Modal component that displays a warning when deleting a default ship-from location
 * that may affect returns configuration. Includes a button to update return settings.
 * @param {object} props - Component props
 * @param {() => void} props.onClose - Function to call when the modal should be closed
 * @returns {JSX.Element} The returns warning modal component
 */
const ReturnsWarningShipFromModal = ({ onClose }) => {
  const intl = useIntl();

  // Get the first active store that supports enhanced returns
  // This pattern is similar to what's used in the returns page index
  // Note: This modal only renders when isReturnRabbitError is true, which means
  // there's a returns configuration error, so at least one store with enhanced returns should exist
  const firstStoreWithReturns = useSelector((state) => {
    const activeStores = Global.selectSellerActiveStores(state);
    return activeStores.find((store) => store.supportsEnhancedReturns);
  });

  return (
    <ModalPortal onClose={onClose}>
      <Modal>
        <ModalHeader>
          <Text className={style.modalHeaderText} textType={TextType.H4} value={messages.returnsWarningHeader} />
        </ModalHeader>
        <ModalBody className={style.modalBody}>
          <Text textType={TextType.Paragraph} value={messages.returnsWarningMessage} />
        </ModalBody>
        <ModalFooter className={style.modalFooter}>
          <SsrSignOnButton
            label={intl.formatMessage(messages.updateReturnToLocation)}
            shouldShowIcon={false}
            storeGuid={firstStoreWithReturns?.storeGuid}
            theme='primary'
          />
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

export default AsModal(ReturnsWarningShipFromModal);
